import { motion } from 'framer-motion'
import React, { useState } from 'react'
import { Link as LinkNav } from 'react-router-dom'
import { Link } from 'react-scroll'

import img5 from '../../assets/images/pages/investment/hero-bg.png'
import img5Mob from '../../assets/images/pages/investment/hero-bg-mob.png'
// import img1 from '../../assets/images/pages/main/1.jpg'
// import img1Mob from '../../assets/images/pages/main/1-mob.jpg'
// import img6 from '../../assets/images/pages/main/5.jpg'
// import img6Mob from '../../assets/images/pages/main/5-mob.jpg'
// import img7 from '../../assets/images/pages/main/6.jpg'
// import img7 from '../../assets/images/pages/main/7.jpg'
// import img7Mob from '../../assets/images/pages/main/7.jpg'
import img8 from '../../assets/images/pages/main/8.jpg'
import img8Mob from '../../assets/images/pages/main/8-mob.jpg'
import img9 from '../../assets/images/pages/main/9.jpg'
import img9Mob from '../../assets/images/pages/main/9-mob.jpg'
// import img2 from '../../assets/images/pages/main/2.jpg'
// import img2Mob from '../../assets/images/pages/main/2-mob.jpg'
// import img3 from '../../assets/images/pages/main/3.jpg'
// import img3Mob from '../../assets/images/pages/main/3-mob.jpg'
// import img4 from '../../assets/images/pages/main/4.jpg'
// import img4Mob from '../../assets/images/pages/main/4-mob.jpg'
import { delayAnimation, ease, speedAnimation } from '../../helpers/animations'
import HeroSlider from '../HeroSlider/HeroSlider'
import { HeroSliderPicture } from '../HeroSlider/HeroSlider.types'
import style from './MainHero.module.scss'

const images: HeroSliderPicture[] = [
  // {
  //   mob: img1Mob,
  //   desk: img1,
  // },
  {
    mob: img9Mob,
    desk: img9,
    class: 'photo-1',
  },
  // {
  //   mob: img2,
  //   desk: img2,
  //   class: 'photo-1',
  // },
  // {
  //   mob: img3,
  //   desk: img3,
  //   class: 'photo-1',
  // },
  {
    mob: img5Mob,
    desk: img5,
    class: 'gradient-1',
  },
  // {
  //   mob: img2Mob,
  //   desk: img2,
  // },
  // {
  //   mob: img3Mob,
  //   desk: img3,
  // },
  // {
  //   mob: img4Mob,
  //   desk: img4,
  // },
]

const MotionWraper = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: any
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, position: 'absolute', zIndex: 1 }}
      animate={{ opacity: 1 }}
      transition={{ duration: speedAnimation, ease }}
      viewport={{ once: true }}
      exit={{
        opacity: 0,
        transition: {
          duration: speedAnimation,
          delay: delayAnimation,
        },
      }}
      className={className}
    >
      {children}
    </motion.div>
  )
}

export const MainHero = (props: {
  collectionId: number | string
  btnName?: string
}) => {
  const { collectionId, btnName = 'Смотреть подборку недели' } = props
  const [currentData, setCurrentData] = useState<number>(0)
  const HeroData = [
    {
      title: 'Пространство <br>выбора',
      lead: 'Какие квартиры стоят вашего внимания прямо сейчас — для себя или инвестиций',
      btn: {
        text: btnName,
        link: `#collection-${collectionId}`,
      },
    },
    // {
    //   title: 'Пространство <br>выбора',
    //   lead: 'Какие квартиры стоят вашего внимания прямо сейчас — для себя или инвестиций',
    //   btn: {
    //     text: btnName,
    //     link: `#collection-${collectionId}`,
    //   },
    // },
    // {
    //   title: 'Пространство <br>выбора',
    //   lead: 'Какие квартиры стоят вашего внимания прямо сейчас — для себя или инвестиций',
    //   btn: {
    //     text: btnName,
    //     link: `#collection-${collectionId}`,
    //   },
    // },
    {
      title: 'Инвестируй <br>в будущее',
      lead: 'Покупка квартиры как способ сохранить <br class="for-desktop">свои деньги',
      btn: {
        text: 'Выбрать квартиру для инвестиций',
        link: '/invest/',
      },
    },
    // {
    //   mob: img5Mob,
    //   desk: img5,
    // },
  ]

  const sliderChange = (swiper: any) => {
    if (swiper.realIndex === HeroData.length - 1) {
      setCurrentData(1)
      // } else if (swiper.realIndex === 2) {
      //   setCurrentData(2)
      // } else if (swiper.realIndex === 1) {
      //   setCurrentData(1)
    } else {
      setCurrentData(0)
    }
  }

  return (
    <div className={style.MainHero}>
      <HeroSlider
        images={images}
        speed={400}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        delay={2500}
        onChange={sliderChange}
      />
      <MotionWraper
        className={[style.MainHero__container, 'theme-white'].join(' ')}
      >
        <h1
          dangerouslySetInnerHTML={{ __html: `${HeroData[currentData].title}` }}
        ></h1>
        <div
          className={style.MainHero__lead}
          dangerouslySetInnerHTML={{ __html: `${HeroData[currentData].lead}` }}
        ></div>
      </MotionWraper>
      <MotionWraper className={style.MainHero__btn}>
        {currentData === 0 ? (
          <Link
            to={`${HeroData[currentData]?.btn?.link}`}
            className='btn btn--main btn--hover-gray'
            smooth={true}
          >
            {`${HeroData[currentData]?.btn?.text}`}
          </Link>
        ) : (
          <LinkNav
            to={`${HeroData[currentData]?.btn?.link}`}
            className='btn btn--main btn--hover-gray'
          >
            {`${HeroData[currentData]?.btn?.text}`}
          </LinkNav>
        )}
      </MotionWraper>
    </div>
  )
}
